import _ from "lodash";
import XLSX from "xlsx";

export default {
    methods: {
        addZero(month) {
            return month.toString().length > 1 ? `${month}` : `0${month}`;
        },
        setDateDiff(dd) {
            let today = new Date();
            let mday = new Date(today.setDate(today.getDate() + dd));
            let [myear, mmonth,mdd] = [mday.getFullYear(), mday.getMonth(), mday.getDate()];
            let fromDate =`${myear}-${this.addZero(mmonth + 1)}-${this.addZero(mdd)}`;

            today = new Date();
            [myear, mmonth,mdd] = [today.getFullYear(), today.getMonth(), today.getDate()];
            let toDate =`${myear}-${this.addZero(mmonth + 1)}-${this.addZero(mdd)}`;
            let tmpDate = fromDate;
            if (fromDate > toDate) {
                tmpDate = toDate;
                toDate  = fromDate;
                fromDate = tmpDate;
            }
            return {fromDate, toDate}
        },
        setTableDateFormat(date) {
            return !_.isEmpty(date)
                ? date.substring(0, 10)
                : date
        },
        setDotsDate(date) {
            if (!date) return "";
            const replaceDate = date.replace("T", " ").substr(0, 10);
            return replaceDate.replaceAll("-", ".");
        },
        setDashDate(date) {
          if (!date) return "";
          return `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;
        },
        // 엑셀 서식 2025.1.1 -> 20250101
        setNoDotsDate(serial) {
            const date = XLSX.SSF.parse_date_code(serial);
            if (!date) return "";

            const year = date.y;
            const month = String(date.m).padStart(2, "0");
            const day = String(date.d).padStart(2, "0");
            return `${year}${month}${day}`;
        },
        getNowMonthAllDate() {
            const now = new Date();
            const year = now.getFullYear();
            const month = now.getMonth() + 1;

            // 현재 월의 1일
            const fromDate = `${year}-${String(month).padStart(2, '0')}-01`;

            // 현재 월의 마지막날
            const lastDay = new Date(year, month, 0).getDate();
            const toDate = `${year}-${String(month).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;

            return {fromDate, toDate};
        },
        getNowMonth() {
            const now = new Date();
            const year = now.getFullYear();
            const month = now.getMonth() + 1;
            return `${year}-${this.addZero(month)}`;
        },
        getYearList(startYear, endYear) {
            const result = [];

            const startStr = String(startYear || "");
            const endStr = endYear ? String(endYear) : "";

            if (startStr.length < 4) return [];

            let year = Number(startStr.slice(0, 4));
            let targetYear;

            if (endStr && endStr.length >= 4) {
                targetYear = Number(endStr.slice(0, 4));
            } else {
                targetYear = new Date().getFullYear();
            }

            while (year <= targetYear) {
                result.unshift(String(year));
                year++;
            }

            return result;
        },
        getYearMonthList(startYm, endYm) {
            const result = [];

            const startStr = String(startYm || "");
            const endStr = endYm ? String(endYm) : "";

            if (startStr.length < 6) return [];

            let year = Number(startStr.slice(0, 4));
            let month = Number(startStr.slice(4, 6));

            let targetYear, targetMonth;

            if (endStr && endStr.length >= 6) {
                targetYear = Number(endStr.slice(0, 4));
                targetMonth = Number(endStr.slice(4, 6));
            } else {
                const now = new Date();
                targetYear = now.getFullYear();
                targetMonth = now.getMonth() + 1;
            }

            while (year < targetYear || (year === targetYear && month <= targetMonth)) {
                const ym = year.toString() + String(month).padStart(2, "0");
                result.unshift(ym);

                month++;
                if (month > 12) {
                    month = 1;
                    year++;
                }
            }
            return result;
        },
        formatSimpleDate(date) {
            if (!date || date.length !== 8) return date;

            const year = date.substring(0, 4);
            const month = date.substring(4, 6);
            const day = date.substring(6, 8);

            return `${year}.${parseInt(month)}.${parseInt(day)}`;
        }
    }
}